if (typeof $ == 'undefined') {
    //load jquery from cdn then excecute collectionTabsJS
    var script = document.createElement('script');
    script.src = "https://code.jquery.com/jquery-3.4.1.min.js";
    script.onload = function () {
        collectionTabsJS();
    };
    document.head.appendChild(script);
} else {
    collectionTabsJS();
}
function collectionTabsJS(){
    $(".collectionTabTitle").on("click", function(){
        $(".collectionTabTitle").removeClass("active");
        $(".collectionTabContent").removeClass("active");
        $(this).addClass("active");
        let tabId = $(this).attr("data-index");
        $(this).closest(".collectionTabsWrapper").find(".collectionTabContent[data-index='"+tabId+"']").addClass("active");
    });
}